import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const OfferIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "83px", height: props.height ?? "72px" }}
    >
      <svg
        {...props}
        viewBox="0 0 83 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1620_32235"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="83"
          height="72"
        >
          <rect x="0.5" width="82" height="72" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1620_32235)"></g>
        <g clipPath="url(#clip0_1620_32235)">
          <mask
            id="mask1_1620_32235"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="12"
            width="51"
            height="51"
          >
            <path
              d="M0.9021 61.5727V12.7739H49.4023V61.5727H0.9021Z"
              fill="white"
              stroke="white"
              strokeWidth="1.5"
            />
          </mask>
          <g mask="url(#mask1_1620_32235)">
            <path
              d="M47.5102 35.7369L47.5012 35.7261L43.7661 31.9272"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.72609 31.6553L2.79419 35.7366"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.72607 37.6046V15.5315C6.72607 14.0019 7.95859 12.7603 9.48091 12.7603H41.0112C42.5317 12.7603 43.766 14.0001 43.766 15.5315V37.4949"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.5559 41.1519H29.9349"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.8905 29.8975H19.6562V35.4436"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.6543 32.6182H21.7115"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M27.5824 29.8975H25.3481V35.4436"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.3481 32.6182H27.4053"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.949 29.8501H30.6306V35.3873H32.949"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.7771 32.6182H30.6287"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M37.2812 32.7456L39.6139 35.4125"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M36.6123 29.8237V35.4113"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M39.614 31.276C39.614 32.0785 38.9146 32.7282 38.0881 32.7282C37.6785 32.7282 36.623 32.7354 36.623 32.7354C36.623 32.7354 36.6159 31.6809 36.6159 31.276C36.6159 30.943 36.6123 29.8237 36.6123 29.8237H38.0881C38.9146 29.8237 39.614 30.4734 39.614 31.276Z"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.2449 32.6702C16.2449 34.2142 15.0016 35.4648 13.4668 35.4648C11.932 35.4648 10.6887 34.2142 10.6887 32.6702C10.6887 31.1262 11.932 29.8755 13.4668 29.8755C15.0016 29.8755 16.2449 31.1262 16.2449 32.6702Z"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M41.7303 38.6861L46.884 35.6683C47.2381 35.4613 47.6836 35.7187 47.6836 36.1308V58.7473C47.6836 60.3147 46.4206 61.5852 44.8626 61.5852H5.44162C3.88353 61.5852 2.62061 60.3147 2.62061 58.7473V36.1398C2.62061 35.7223 3.06961 35.4631 3.42917 35.6719L24.6879 48.1193C24.9741 48.2866 25.3301 48.2866 25.6163 48.1193L41.7303 38.6843"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26.9474 18.7562H23.5432V17.232C23.5432 16.6813 23.9868 16.2368 24.5324 16.2368H25.9564C26.5038 16.2368 26.9456 16.6831 26.9456 17.232V18.7562H26.9474Z"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M29.5001 26.0716H20.9924C20.5183 26.0716 20.1355 25.6847 20.1355 25.2096V19.6203C20.1355 19.1434 20.5201 18.7583 20.9924 18.7583H29.5001C29.9742 18.7583 30.357 19.1452 30.357 19.6203V25.2096C30.357 25.6865 29.9724 26.0716 29.5001 26.0716Z"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M40.8056 57.56L23.2659 47.29"
              stroke="#7BBC7B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <mask
          id="mask2_1620_32235"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="50"
          y="8"
          width="33"
          height="33"
        >
          <rect x="50.1521" y="8" width="32" height="32.1911" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask2_1620_32235)">
          <path
            d="M58.2549 33.6894H65.2806V28.426H58.2549V33.6894ZM58.2549 26.6001H65.2806V17.1474H58.2549V26.6001ZM67.0239 33.6894H74.0496V24.2367H67.0239V33.6894ZM67.0239 22.4109H74.0496V17.1474H67.0239V22.4109ZM57.3316 36.5898C56.8194 36.5898 56.3836 36.4017 56.0243 36.0256C55.6652 35.6493 55.4856 35.1929 55.4856 34.6564V16.1804C55.4856 15.644 55.6652 15.1876 56.0243 14.8112C56.3836 14.4351 56.8194 14.2471 57.3316 14.2471H74.9729C75.4852 14.2471 75.9209 14.4351 76.2803 14.8112C76.6394 15.1876 76.8189 15.644 76.8189 16.1804V18.8661H78.5626V19.9403H76.8189V24.8815H78.5626V25.9553H76.8189V30.8966H78.5626V31.9708H76.8189V34.6564C76.8189 35.1929 76.6394 35.6493 76.2803 36.0256C75.9209 36.4017 75.4852 36.5898 74.9729 36.5898H57.3316ZM57.3316 35.5156H74.9729C75.178 35.5156 75.366 35.4261 75.5369 35.2471C75.7078 35.0681 75.7933 34.8712 75.7933 34.6564V16.1804C75.7933 15.9656 75.7078 15.7687 75.5369 15.5897C75.366 15.4108 75.178 15.3213 74.9729 15.3213H57.3316C57.1265 15.3213 56.9385 15.4108 56.7676 15.5897C56.5967 15.7687 56.5113 15.9656 56.5113 16.1804V34.6564C56.5113 34.8712 56.5967 35.0681 56.7676 35.2471C56.9385 35.4261 57.1265 35.5156 57.3316 35.5156Z"
            fill="#7BBC7B"
          />
        </g>
        <mask
          id="mask3_1620_32235"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="54"
          y="37"
          width="26"
          height="26"
        >
          <rect
            x="54.1521"
            y="37.1733"
            width="25"
            height="25.1493"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask3_1620_32235)">
          <path
            d="M63.2243 61.3827L57.215 55.089C57.0653 54.9294 56.9514 54.7503 56.8733 54.5518C56.7952 54.3532 56.7561 54.1521 56.7561 53.9485C56.7561 53.7308 56.7952 53.5263 56.8733 53.3348C56.9514 53.1433 57.0653 52.9658 57.215 52.8021L63.485 46.2354L60.4561 43.0949L61.3053 42.2158L71.3986 52.8133C71.5623 52.9764 71.6812 53.154 71.7553 53.346C71.8293 53.5378 71.8663 53.7427 71.8663 53.9607C71.8663 54.1649 71.8293 54.3659 71.7553 54.5638C71.6812 54.7618 71.5619 54.9403 71.3975 55.0994L65.4079 61.3827C65.2517 61.5395 65.0821 61.6588 64.8993 61.7406C64.7165 61.8224 64.5212 61.8633 64.3134 61.8633C64.119 61.8633 63.9269 61.8224 63.7374 61.7406C63.5478 61.6588 63.3768 61.5395 63.2243 61.3827ZM64.3142 47.1041L58.004 53.7232C57.9641 53.7652 57.9374 53.8071 57.9241 53.8489C57.9107 53.8909 57.904 53.9329 57.904 53.9749H70.7345C70.7345 53.9329 70.7278 53.8909 70.7144 53.8489C70.7011 53.8071 70.6743 53.7652 70.6342 53.7232L64.3142 47.1041ZM74.6657 61.8633C74.147 61.8633 73.7083 61.6719 73.3496 61.2892C72.9911 60.9063 72.8118 60.4403 72.8118 59.8911C72.8118 59.4553 72.8886 59.0425 73.042 58.6526C73.1957 58.263 73.4047 57.9038 73.6691 57.5751L74.6749 56.2302L75.7004 57.5751C75.9542 57.9038 76.1605 58.263 76.3194 58.6526C76.4782 59.0425 76.5577 59.4553 76.5577 59.8911C76.5577 60.4473 76.3737 60.9151 76.0058 61.2944C75.638 61.6737 75.1913 61.8633 74.6657 61.8633Z"
            fill="#7BBC7B"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
